import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aqar23-c6',
  templateUrl: './aqar23-c6.component.html',
  styleUrls: ['./aqar23-c6.component.scss']
})
export class Aqar23C6Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
